import { render, staticRenderFns } from "./CertificadoCongreso.vue?vue&type=template&id=174d4bea&scoped=true"
import script from "./CertificadoCongreso.vue?vue&type=script&lang=js"
export * from "./CertificadoCongreso.vue?vue&type=script&lang=js"
import style0 from "./CertificadoCongreso.vue?vue&type=style&index=0&id=174d4bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174d4bea",
  null
  
)

export default component.exports